module.exports = __webpack_public_path__ + "static/media/iconBar.e98c3118.svg";